import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './App/App';

import 'virtual:theme.css';
import '@style/global.css';

const container = document.getElementById('js-mapframe');
const root = createRoot(container);

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
});

root.render(<App />);